import {dialog} from '@/modules/layout'
import {GLobalSearchPatientsDialog} from '@/modules/patients/components/dialogs/global-search-patients-dialog/global-search-patients-dialog'

const GLOBAL_SEARCH_DIALOG_ID = 'global-search'

export function openGlobalSearchPatientsDialog() {
  const id = GLOBAL_SEARCH_DIALOG_ID

  try {
    dialog.remove(id)
  } catch {}

  return dialog.open(id, {
    id,
    children: <GLobalSearchPatientsDialog />,
    hideCloseButton: true,
    closeOnInteractOutside: true,
  })
}

export function getGlobalSearchPatientsDialog() {
  try {
    return dialog.get(GLOBAL_SEARCH_DIALOG_ID)
  } catch {
    return null
  }
}

export function isGlobalSearchPatientsDialogOpen() {
  return Boolean(getGlobalSearchPatientsDialog())
}
